import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/page_icons/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-4f859b16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "agenda" }
const _hoisted_2 = {
  id: "container",
  class: "row"
}
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "row elements-centering" }
const _hoisted_5 = { class: "magenta" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row elements-centering" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "calendar",
    src: _imports_0
  })
], -1))
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { class: "magenta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: true }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("PAGE.AGENDA")), 1)
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("AGENDA.TIP_NEW_EVENT")), 1),
        _createVNode(_component_Calendar)
      ])
    ])
  ]))
}